import { useI18n } from '../../context/useI18n';

/** Cabecera estándar «← Volver a Maestros» en pantallas del hub de maestros gym. */
export default function MastersBackHeader({ onBack, title = null }) {
  const { t } = useI18n();
  return (
    <header className="mb-4">
      <button
        type="button"
        className="btn-secondary panel-back-btn mb-3"
        onClick={onBack}
      >
        {t('gym.masters.back', '← Volver a Maestros')}
      </button>
      {title ? (
        <h2 className="text-xl font-bold d28d-page-title notranslate" translate="no">{title}</h2>
      ) : null}
    </header>
  );
}
